import { Provider } from '@/features/game-context/types';
import {
  getErrorType,
  getErrorTypeByCategory,
  getMatureErrorMessage,
} from '@/features/game-window-integration/helpers/error-mapping';
import { gcmState } from '@/features/game-window-integration/helpers/GCM/state';
import { WrapperProxy } from '@/features/wrapper-proxy/wrapper-proxy';

export const handleRecoverableErrorCallback = (): void => {
  if (!gcmState.initComplete || !gcmState.gcm) return;

  gcmState.gcm.resume();
};

export const onGcmInit = (): void => {
  if (!gcmState.gcm) return;

  const eventCallbacks = [
    { id: gcmState.gcm.callbacks.ANIMATION_COMPLETE },
    {
      id: gcmState.gcm.callbacks.HANDLE_ERROR,
      show_ui: gcmState.showErrorDialog,
    },
    {
      id: gcmState.gcm.callbacks.HANDLE_MSG_TRIGGER,
      show_ui: gcmState.showMsgTriggerDialog,
    },
  ];

  gcmState.gcm.registerCallbacks(eventCallbacks, gcmState.haveOwnCui);
};

export const handleError = (
  errorCategory: unknown,
  errorSeverity: unknown,
  errorCode: string,
  errorMessage: string,
): void => {
  WrapperProxy.setSpinInProgress(false);

  const payload = {
    errorCategory,
    errorSeverity,
    errorCode,
    errorMessage,
  };

  const errorType =
    getErrorTypeByCategory(errorCategory, Provider.LNW) ??
    getErrorType(errorCode, Provider.LNW, false, payload);

  WrapperProxy.setProviderError({
    display: true,
    errorCode,
    errorMessage: getMatureErrorMessage(errorCode, errorMessage),
    errorType,
  });
  gcmState.errorCallback = handleRecoverableErrorCallback;
};

export const gameAnimationComplete = (): void => {
  if (!gcmState.gcm) return;
  gcmState.gcm.resume();
  WrapperProxy.setSpinInProgress(false);
};

export const gameAnimationStart = (): void => {
  WrapperProxy.setSpinInProgress(true);
};

export const gameReady = (): void => {
  WrapperProxy.setGameLoaded();
};

export const optionHasChanged = (
  optionType: string,
  val: boolean | string | number,
): void => {
  gcmState.options[optionType] = val;
  if (optionType === 'MUTE') {
    WrapperProxy.setAudio(!val);
  }
};

export const dialogAcknowledged = (): void => {
  if (!gcmState.errorCallback) return;
  gcmState.errorCallback();
};

export const handleRealityCheckErrorCallback = (): void => {
  if (!gcmState.gcm) return;
  gcmState.gcm.resume();
};

export const reload = (): void => {
  window.location.reload();
};

export const redirect = (redirectUrl: string): void => {
  WrapperProxy.setGameLauncherClosed();
  window.location.replace(redirectUrl);
};

export const returnToLobby = (): void => {
  WrapperProxy.setGameLauncherClosed();
};

export const loadProgressUpdate = (prog: number): void => {
  WrapperProxy.setGameLoadProgress(prog);
};
